/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />
/// <reference path="../../_ext/Bases/DialogBase.ts" />
/// <reference path="../../_ext/Bases/GridBase.ts" />
namespace TabAurous.Production {

    import fld = WorkOrderItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class WorkOrderSelectItemsEditor extends _Ext.MFGTransItemGridEditor<WorkOrderItemsRow> {


        protected getColumnsKey() { return "Production.WorkOrderSelectItems"; }
        protected getDialogType() { return WorkOrderItemsDialog; }
        protected getLocalTextPrefix() { return WorkOrderItemsRow.localTextPrefix; }
        protected form: WorkOrderItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables 
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = false;
        public TotalItems: number;
        public isUpdate: number;
        public canUpdate: number;
        public DismantlingType: number;
        public currentrow: WorkOrderItemsRow;

        public StoneDiscount: number;
        public LaborDiscount: number;

        public TransDate: Date;
        statement: string;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            //   this.slickGrid.setOptions({ forceFitColumns: true, showFooterRow: true });
        }
        // #region Column Add -Remove 
        protected getColumns() {

            let columns = super.getColumns();
            let piecesColumn = Q.first(columns, x => x.field == fld.Pieces);

            //piecesColumn.format = ctx => {
            //    if (ctx.item.RefTransId == "0") 
            //        return ColumnFormatter.integerInputFormatter(ctx, this);
            //    else
            //        return ColumnFormatter.integerReadOnlyFormatter(ctx,this);
            //}
            //let weightColumn = Q.first(columns, x => x.field == fld.Weight);

            //weightColumn.format = ctx => {
            //    if (ctx.item.RefTransId == "0")
            //        return ColumnFormatter.WeightFormatter(ctx, this);
            //    else
            //        return ColumnFormatter.ReadOnlyWeightFormatter(ctx, this);
            //}
            //let netwweightColumn = Q.first(columns, x => x.field == fld.NetWeight);

            //netwweightColumn.format = ctx => {
            //    if (ctx.item.RefTransId == "0")
            //        return ColumnFormatter.WeightFormatter(ctx, this);
            //    else
            //        return ColumnFormatter.ReadOnlyWeightFormatter(ctx, this);
            //}
            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            let cell = this.slickGrid.getCellFromEvent(e);
            let item = this.itemAt(cell.row);
            let input = $(e.target);
            let field = input.data('field');
            let text = Q.coalesce(Q.trimToNull(input.val()), '0');
            let id = this.id(item);
            let pending = this.pendingChanges[id];

            // *** Format Number ***
            let effective = this.getEffectiveValue(item, field);
            let oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            let value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces) {
                let i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                item[field] = value;
            }



            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            let id = this.id(item);
            let pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            //set selected row line no and BOM selection
            this.slickGrid.setSelectedRows([row]);

            let item = this.itemAt(row);
            this.currentrow = this.itemAt(row);
            (this.parentDialog as WorkOrderDialog).form.Pieces.value = item.Pieces;

            let target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {

                    //TODO: Validate for TransItemID in RefTransItemID in Stock
                    Q.confirm('Are you sure want to Delete? ', () => {
                        let id = this.id(item);

                        //let id = this.id(item);
                        //let refid = Stock.StockItemRow.getLookup().items.filter(x => x.RefTransItemId == item.TransItemId && x.RefVoucherId == item.VoucherTypeId && x.RefTransId == item.TransId)[0];
                        //if (refid != null) {
                        //    if (refid.PartyId != null || refid.PartyId > 0) {
                        //        Q.alert("This Item has been used in transactions Cannot Delete!");
                        //        return;
                        //    }
                        //} else {

                        //    this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);
                        this.element.trigger('dialogclose');
                        //}
                    });

                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                    let detailitems = (this.parentDialog as WorkOrderDialog).form.ItemDetails.getItems().length;
                    if (detailitems > 0) {
                        q.alert('', 'Cannot Edit as Details are added', true, 2999);
                        return;
                    }
                }
            }
            this.view.refresh();

        }
        //public initDialog(dialog: _Ext.DialogBase<WorkOrderDialog, any>): void {
        //    super.initDialog(dialog);

        //    dialog.parentGrid = this;
        //    let x = 1;
        //}
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                onClick: () => {

                    // **** Validate Party before Item Selection ****


                    let grid = Common.ProductSelectGrid;
                    let filters: _Ext.SelectGridFilters = {
                        FilterItems: 5
                    }

                    let pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                    });
                    pickerDialog.onSuccess = (selectedItems: OMS.ProductMasterRow[]) => {
                        selectedItems = selectedItems.filter(x => x != undefined);
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId && n.AttributeId == t.AttributeId && n.Line_No != 0) });
                        let self = this;
                        let details = [];
                        let lineno;
                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: OMS.ProductMasterRow) {
                            Purchase.PurchaseMasterService.GetLineNo({}, response => lineno = response.Line_No, {
                                async: false
                            });

                            let AtbId = value.AttributeId;
                            let bomdetails = [];
                            let labordetail = [];

                            // #region Product Attributes

                            let oldbomdetails = value.BOMDetails;
                            for (let j = 0; j < oldbomdetails.length; j++) {
                                let oldbom = oldbomdetails[j];
                                let bom: WorkOrderBOMRow = {
                                    ProductId: oldbom.ProductId,
                                    ProductCode: oldbom.ProductCode,
                                    BomProductId: oldbom.BOMProductId,
                                    AttributeId: oldbom.BOMAttributeId,
                                    CalcOnId: oldbom.CalcOnId,
                                    Pieces: oldbom.Pieces,
                                    Weight: oldbom.Weight,
                                    ItemType: oldbom.ItemType,
                                    ItemTypeId: oldbom.ItemTypeId,
                                    StoneColorId: oldbom.StoneColorId,
                                    Attribute: oldbom.Attribute,
                                    CertificateNo: oldbom.CertificateNo,
                                    CategoryId: oldbom.CategoryId,
                                    SubCategoryId: oldbom.SubCategoryId,
                                    ProductTypeId: oldbom.ProductTypeId,
                                    QualityId: oldbom.QualityId,
                                    SieveId: oldbom.SieveId,
                                    ShapeId: oldbom.ShapeId,
                                    StoneSizeId: oldbom.StoneSizeId,
                                    SettingId: oldbom.SettingId,
                                    GroupSieveId: oldbom.GroupSieveId,
                                    StoneCuletId: oldbom.StoneCuletId,
                                    StoneCutId: oldbom.StoneCutId,
                                    StoneFluorescenceId: oldbom.StoneFluorescenceId,
                                    StoneGirdleId: oldbom.StoneGirdleId,
                                    StonePolishId: oldbom.StonePolishId,
                                    StoneSymmetryId: oldbom.StoneSymmetryId,
                                    StoneDepth: oldbom.StoneDepth,
                                    StoneTable: oldbom.StoneTable,

                                    KaratId: oldbom.KaratId,
                                    MetalColorId: oldbom.MetalColorId,
                                    Purity: oldbom.Purity,
                                    PureWeight: oldbom.PureWeight,
                                };
                                bomdetails.push(bom);
                            }
                            let x = value["ProductId"];

                            let currentrow: WorkOrderItemsRow = {
                                ProductId: value.ProductId
                            };
                            let x21 = {};
                            //let keys = Object.keys(value);

                            //let keys1 = Object.keys(CommonProduct);
                            //let ty1 = CommonProduct["ProductId"];
                            //let ty11 = CommonProduct["ProductId1"];
                            //let x221 = CommonProduct["ProductId"];
                            if (WorkOrderItemsRow["ProductId"] != undefined)
                                x21["ProductId"] = 1;
                            let purchase: WorkOrderItemsRow = {
                                ProductId: value.ProductId,
                                AttributeId: value.AttributeId,
                                Attribute: value.Attribute,
                                ProductCode: value.ProductCode,
                                ProductName: value.ProductName,
                                ItemTypeId: value.ItemTypeId,
                                HasBom: value.HasBom,
                                CategoryId: value.CategoryId,
                                CategoryName: value.CategoryName,
                                ProductTypeId: value.ProductTypeId,
                                ProductTypeName: value.ProductTypeName,
                                SubCategoryId: value.SubCategoryId,
                                SubCategoryName: value.SubCategoryName,
                                BrandId: value.BrandId,
                                SuperTypeId: value.SuperTypeId,
                                CollectionId: value.CollectionId,
                                ProductSizeId: value.ProductSizeId,
                                Pieces: value.Pieces,
                                Weight: value.Weight,
                                OtherPieces: value.OtherPieces,
                                OtherWeight: value.OtherWeight,
                                StonePieces: value.StonePieces,
                                StoneWeight: value.StoneWeight,
                                NetWeight: value.NetWeight,
                                DiamondPieces: value.DiamondPieces,
                                DiamondWeight: value.DiamondWeight,
                                CalcOnId: value.CalcOnId,
                                BOMDetails: bomdetails,
                                HSN: value.HSN,
                                TaxCode: value.TaxCode,
                                MetalId: value.MetalId,
                                KaratId: value.KaratId,
                                MetalColorId: value.MetalColorId,
                                QualityId: value.QualityId,
                                SieveId: value.SieveId,
                                ShapeId: value.ShapeId,
                                StoneColorId: value.StoneColorId,
                                StoneSizeId: value.StoneSizeId,
                                ImageName: value.ImageName,
                                StoneCutId: value.StoneCutId,
                                StonePolishId: value.StonePolishId,
                                StoneSymmetryId: value.StoneSymmetryId,
                                StoneFluorescenceId: value.StoneFluorescenceId,
                                StoneCuletId: value.StoneCuletId,
                                StoneGirdleId: value.StoneGirdleId,
                                StoneTable: value.StoneTable,
                                StoneDepth: value.StoneDepth,
                                Purity: value.Purity,
                                CalcUnitId: value.CalcUnitId,
                                PureWeight: value.Weight * value.Purity,
                                Line_No: lineno,
                                Parts: value.Parts
                            };

                            details.push(purchase);

                        });

                        if (this.view.getItems().length > 0) {
                            self.TotalItems = details.length + this.view.getItems().length;
                        }
                        else {
                            self.TotalItems = details.length;
                        }
                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Detail);
                        }

                        // #endregion

                        // #endregion
                    }


                    pickerDialog.dialogOpen();
                }
            });

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select SO",
                cssClass: "order-button",
                hotkey: "alt+i",
                hint: 'alt+i',
                onClick: () => {
                    let grid = SalesOrder.OrderItemsForWorkOrderGrid;
                    let filters: _Ext.SelectGridFilters = {
                        InStock: false
                    }

                    let pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true, title: "Select Items", GridFilters: filters,
                        preSelectedKeys: this.value.map(k => k.ProductId)
                    });
                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        selectedItems = selectedItems.filter(x => x != undefined);
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId && n != undefined) });
                        let self = this;
                        let details = [];

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: SalesOrder.SalesOrderItemsRow) {
                            let PrdId = value.ProductId;
                            let AtbId = value.AttributeId;
                            let bomdetails = [];
                            let labordetail = [];
                            let PrdDetails = value;


                            // #region Product Attributes
                            // **** Load & assign Attributes of Product using AtbID ****
                            let voucherdetails;
                            SalesOrder.SalesOrderService.Retrieve(
                                { EntityId: (value.TransId) },
                                response => {
                                    if (response.Entity == undefined || response.Entity == null) {
                                        q.alert('', 'Sales Order Not Found!', true, 2999);
                                        return;
                                    }
                                    voucherdetails = response.Entity
                                }, { async: false });
                            let oldbomdetails = value.BOMDetails;
                            for (let j = 0; j < oldbomdetails.length; j++) {
                                let oldbom = oldbomdetails[j];
                                let bom: WorkOrderBOMRow = {
                                    BomProductId: oldbom.BOMProductId,
                                    AttributeId: oldbom.BOMAttributeId,
                                    Pieces: oldbom.Pieces,
                                    Weight: oldbom.Weight,
                                    Line_No: value.Line_No,
                                    Purity: oldbom.Purity == undefined ? 0 : oldbom.Purity,
                                    PureWeight: oldbom.Purity * oldbom.Weight,
                                    ProductId: oldbom.ProductId,
                                    RefTransBomId: oldbom.TransBomId,
                                    RefTransItemId: oldbom.TransItemId,
                                    RefVoucherId: value.VoucherTypeId,
                                    RefTransId: value.TransId,
                                    CompanyId: value.CompanyId,
                                };
                                bomdetails.push(bom);
                            }
                            let purchase: WorkOrderItemsRow = {
                                ProductId: PrdId,
                                ProductCode: PrdDetails.ProductCode,
                                AttributeId: AtbId,
                                Line_No: value.Line_No,
                                BagNo: value.BagNo,
                                Pieces: value.Pieces,
                                Weight: value.Weight,
                                Parts: value.Parts,
                                OtherPieces: value.OtherPieces,
                                OtherWeight: value.OtherWeight,
                                StonePieces: value.StonePieces,
                                StoneWeight: value.StoneWeight,
                                NetWeight: value.NetWeight,
                                DiamondPieces: value.DiamondPieces,
                                DiamondWeight: value.DiamondWeight,
                                RefTransId: value.TransId,
                                RefTransItemId: value.TransItemId,
                                RefVoucherId: value.VoucherTypeId,
                                DeliveryDate: value.DeliveryDate,
                                POSCustomerId: voucherdetails.PartyId,
                                LedgerName: value.LedgerName,
                                RefVoucherNo: voucherdetails.VoucherNo,
                                Purity: value.Purity,
                                PureWeight: value.PureWeight,
                                BOMDetails: bomdetails,
                                Attribute: value.Attribute,

                            };

                            details.push(purchase);

                        });

                        if (this.view.getItems().length > 0) {
                            self.TotalItems = details.length + this.view.getItems().length;
                        }
                        else {
                            self.TotalItems = details.length;
                        }
                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Detail);
                        }

                        // #endregion

                        // #endregion
                    }



                    pickerDialog.dialogOpen();
                }
            });
            buttons.push({
                title: "Select POSOrders",
                cssClass: "order-button",
                hotkey: "alt+p",
                hint: 'alt+p',
                onClick: () => {
                    let grid = Retail.OrderForPurchaseGrid;
                    let filters: _Ext.SelectGridFilters = {
                        InStock: false
                    }
                    let pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true, title: "Select Items", GridFilters: filters,
                        preSelectedKeys: this.value.map(k => k.ProductId)
                    });
                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        selectedItems = selectedItems.filter(x => x != undefined);
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        let self = this;
                        let details = [];
                        let purchaseLabor = [];
                        let genSKU = this.GenSKU;
                        let rateListId = this.RateListId;
                        let laborListId = this.LaborListId;
                        let laborMarkup = this.LaborMarkup;
                        let rateMarkup = this.StoneMarkup;
                        let newLineNo = this.NewLineNo;
                        let deptId = this.DeptId;
                        let companyId = Q.Authorization.userDefinition.CompanyId;

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: Retail.POSOrderItemsRow) {
                            let PrdId = value.ProductId;
                            let AtbId = value.AttributeId;
                            let bomdetails = [];
                            let labordetail = [];
                            let PrdDetails = value;


                            let voucherdetails;
                            Retail.POSOrderService.Retrieve(
                                { EntityId: (value.TransId) },
                                response => {
                                    if (response.Entity == undefined || response.Entity == null) {
                                        q.alert('', 'POS Order Not Found!', true, 2999);
                                        return;
                                    }
                                    voucherdetails = response.Entity
                                }, { async: false });
                            let oldbomdetails = value.BOMDetails;
                            for (let j = 0; j < oldbomdetails.length; j++) {
                                let oldbom = oldbomdetails[j];
                                let bom: WorkOrderBOMRow = {
                                    BomProductId: oldbom.BOMProductId,
                                    AttributeId: oldbom.BOMAttributeId,
                                    Pieces: oldbom.Pieces,
                                    Weight: oldbom.Weight,
                                    Purity: oldbom.Purity == undefined ? 0 : oldbom.Purity,
                                    PureWeight: oldbom.Purity * oldbom.Weight,
                                    ProductId: oldbom.ProductId,
                                    RefTransBomId: oldbom.TransBomId,
                                    RefTransItemId: oldbom.TransItemId,
                                    RefVoucherId: value.VoucherTypeId,
                                    RefTransId: value.TransId,
                                    CompanyId: value.CompanyId,
                                };
                                bomdetails.push(bom);
                            }
                            let purchase: WorkOrderItemsRow = {
                                ProductId: PrdId,
                                ProductCode: PrdDetails.ProductCode,
                                AttributeId: AtbId,
                                Line_No: value.Line_No,
                                BagNo: value.BagNo,
                                Pieces: value.Pieces,
                                Weight: value.Weight,
                                Parts: value.Parts,
                                OtherPieces: value.OtherPieces,
                                OtherWeight: value.OtherWeight,
                                StonePieces: value.StonePieces,
                                StoneWeight: value.StoneWeight,
                                NetWeight: value.NetWeight,
                                DiamondPieces: value.DiamondPieces,
                                DiamondWeight: value.DiamondWeight,
                                RefTransId: value.TransId,
                                RefTransItemId: value.TransItemId,
                                RefVoucherId: value.VoucherTypeId,
                                DeliveryDate: value.DeliveryDate,
                                POSCustomerId: voucherdetails.POSCustomerId,
                                LedgerName: value.CustomerName,
                                RefVoucherNo: voucherdetails.VoucherNo,
                                PureWeight: value.PureWeight,
                                Purity: value.Purity,
                                Attribute: value.Attribute,
                                BOMDetails: bomdetails,
                            };

                            details.push(purchase);

                        });
                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Detail);
                        }

                        // #endregion

                        // #endregion
                    }


                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }
        // #endregion
        setData(ItemDetails: any[]) {

            for (let Itemdetail of ItemDetails) {
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Itemdetail);
            }
        }

    }
    export interface obj {
        TransItemId?: number;
    }
}